<!--CFS > Scan In-->
<template>
  <a-drawer :title="$t('scanIn')" @close="onClose" :visible="showDrawer" width="95%" :maskClosable="false">
    <a-row type="flex" justify="start" style="margin-top: 30px;">
      <a-col span="10" offset="7">
        <el-card class="box-card" style="padding: 30px;">
          <el-form ref="form" @submit.native.prevent label-width="150px">
            <el-form-item :label="$t('cfs.orderNumber')+':'" style="font-weight: bold;">
              {{$t(orderNumber)}}
            </el-form-item>
            <el-form-item :label="$t('cfs.barcode')+':'">
              <el-input ref="barcodeRef" :placeholder="$t('publicLang.PleaseEnter')" v-model="barCode" maxlength="100" @keyup.enter.native="scanBarcode" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="damageCheck">{{$t('cfs.damage')}}</el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="deleteCheck">{{$t('cfs.delete')}}</el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('userlang.Country')+':'">
              <div style="font-weight: bold;font-size: 48px;">{{$t(country)}}</div>
            </el-form-item>
            <el-form-item :label="$t('generic.Type')+':'">
              <div style="font-weight: bold;font-size: 48px;">{{$t(type)}}</div>
            </el-form-item>
            <a-row style="float: right;">
              <el-button style="margin-left: 45px;" type="success" size="small" @click="scanBarcode">{{$t('userlang.Save')}}</el-button>
            </a-row>
          </el-form>
        </el-card>
      </a-col>
    </a-row>
  </a-drawer>
</template>
<script>
  import ajax from "../../../api/ajax";
  import api from "../../../api/url";
  import { mapState } from "vuex";
  import Template from "../reportCom/template";
  import { Modal } from 'ant-design-vue';
  export default {
    components: {Template},
    data() {
      return {
        showDrawer:false,//显示抽屉
        orderNumber:'',
        country:'',
        type:'',
        barCode:'',
        weightUom:'kg',
        dimUom:'cm',
        damageCheck:false,
        deleteCheck:false,
        CONSOLIDATIONHANDLING:'ORIGIN',//获取系统参数值
      }
    },
    computed: {
      ...mapState(["systemParam"]),
    },
    methods: {
      //关闭抽屉
      onClose() {
        this.showDrawer = false;
        this.reset();
      },
      //重置
      reset(){
        this.orderNumber = ''
        this.barCode = ''
        this.damageCheck = false
        this.country = ''
        this.type = ''
        this.$refs.barcodeRef.focus();
      },
      //打开弹窗
      show(id,type) {
        this.showDrawer = true;
        this.$nextTick(function () {
          this.$refs.barcodeRef.focus();
        });
      },
      scanBarcode() {
        if(this.barCode == null || this.barCode == ''){
          Modal.error({title: this.$t('publicLang.prompt'),content: this.$t('cfs.barcode') +" "+ this.$t('job.notNull')});
          return;
        }
        let params = {
          barcode: this.barCode,
          damage:this.damageCheck
        };

        if(!this.deleteCheck) {
          // 扫入
          ajax.post(api.CFSSCANINSCANBARCODE,params).then(res=>{
            if(res.code == 200){
              this.orderNumber = res.data.orderNumber
              this.country = res.data.country
              this.type = res.data.type
            }else{
              this.orderNumber = ''
              this.country = ''
              this.type = ''
              Modal.error({title: this.$t('publicLang.prompt'),content: res.msg});
            }
            this.barCode = ''
            this.deleteCheck = false;
            this.damageCheck = false;
          })
        } else {
          // 删除
          ajax.post(api.CFSSCANINDELETEBARCODE,params).then(res=>{
            if(res.code == 200){
              this.orderNumber = ''
              this.country = ''
              this.type = ''
              this.barCode = ''
              this.deleteCheck = false;
              this.damageCheck = false;
            }else{
              Modal.error({title: this.$t('publicLang.prompt'),content: res.msg});
            }
          })
        }
        this.$nextTick(function () {
          this.$refs.barcodeRef.focus();
        });
      },
    }
  };
</script>
<style lang="less">

</style>